import { render, staticRenderFns } from "./viewHistory.vue?vue&type=template&id=4796c53a&scoped=true"
import script from "./viewHistory.vue?vue&type=script&lang=js"
export * from "./viewHistory.vue?vue&type=script&lang=js"
import style0 from "./viewHistory.vue?vue&type=style&index=0&id=4796c53a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4796c53a",
  null
  
)

export default component.exports